import { useLayoutEffect } from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';
import { getCircleLayer, getCircleSource } from '@spa/shared/utils/map';
var MAPBOX_STYLE = 'mapbox://styles/uniplaces/cjdg4b5qyg2vp2ss0zhgp2ud7';
mapboxgl.accessToken = process.env.MAPBOX_TOKEN;
var createMapLnglat = function createMapLnglat(zoom, lnglat, zoomSide, containerId, t) {
  var map = new mapboxgl.Map({
    container: containerId,
    center: lnglat,
    style: MAPBOX_STYLE,
    zoom: zoom,
    dragRotate: false
  });
  map.touchZoomRotate.disableRotation();
  map.addControl(new mapboxgl.NavigationControl({
    showCompass: false
  }), zoomSide);
  var uniMarker = createMarker({
    scale: 1.2,
    classList: 'mapbox__marker'
  });
  uniMarker.setLngLat(lnglat);
  uniMarker.addTo(map);
  var uniMarkerTooltip = createMarker({
    classList: 'mapbox__marker__tooltip',
    innerText: t('The exact location will be given only after booking'),
    anchor: 'top'
  });
  uniMarkerTooltip.setLngLat(lnglat);
  uniMarkerTooltip.addTo(map);
  map.on('load', function () {
    map.addSource('location', getCircleSource(lnglat));
    map.addLayer(getCircleLayer(lnglat, 50));
  });
  return map;
};
var createMarker = function createMarker(_ref) {
  var _ref$scale = _ref.scale,
    scale = _ref$scale === void 0 ? 1 : _ref$scale,
    classList = _ref.classList,
    innerText = _ref.innerText,
    anchor = _ref.anchor;
  var element = document.createElement('div');
  element.classList.add(classList);
  if (innerText) {
    element.innerText = innerText;
  }
  return new mapboxgl.Marker({
    scale: scale,
    element: element,
    anchor: anchor
  });
};
var useMap = function useMap(zoom, coordinates) {
  var zoomSide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'bottom-right';
  var containerId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'map';
  var t = arguments.length > 4 ? arguments[4] : undefined;
  mapboxgl.accessToken = process.env.MAPBOX_TOKEN;
  useLayoutEffect(function () {
    if (!coordinates) {
      return;
    }
    var _ref2 = coordinates || {},
      lng = _ref2.lng,
      lat = _ref2.lat;
    createMapLnglat(zoom, [lng, lat], zoomSide, containerId, t);
  }, [zoom, coordinates]);
};
export default useMap;